"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeTranslatedPaths = exports._GetDocumentTranslationLanguage = void 0;
var translation_1 = __importDefault(require("./translation"));
var lodash_1 = require("lodash");
var _GetDocumentTranslationLanguage = function (settings, languageOverride) {
    var language = (languageOverride || translation_1.default.resolvedLanguage || translation_1.default.language || (settings === null || settings === void 0 ? void 0 : settings.defaultLanguage) || '')
        .trim()
        .split(/[-_]/)[0]
        .toLowerCase();
    return language && language !== 'de' ? language : undefined;
};
exports._GetDocumentTranslationLanguage = _GetDocumentTranslationLanguage;
var mergeTranslatedPaths = function (document, translations) {
    if (!translations)
        return document;
    Object.entries(translations).forEach(function (_a) {
        var documentPath = _a[0], value = _a[1];
        return (0, lodash_1.set)(document, documentPath, value);
    });
    return document;
};
exports.mergeTranslatedPaths = mergeTranslatedPaths;
